export default __webpack_public_path__ + "static/media/boitiergris.5605f534.svg";